import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchTaskStates, addState, updateState, deleteState, switchStateOrder, } from "@/features/taskState/services/taskStates";
const useTaskStates = (filterDisplay) => {
    const queryClient = useQueryClient();
    // Include filterDisplay in the query key to ensure proper caching and refetching.
    const { data: taskStatesData, error, isLoading, refetch, } = useQuery(["taskStates", filterDisplay], async () => {
        const statesResponse = await fetchTaskStates();
        const states = statesResponse.states ?? [];
        if (typeof filterDisplay === "boolean") {
            return {
                ...statesResponse,
                states: states.filter((state) => state.indic_display === filterDisplay),
            };
        }
        return statesResponse;
    }, {
        staleTime: 60000,
        keepPreviousData: true,
    });
    // Mutation for adding a new task state.
    const addStateMutation = useMutation((newState) => addState(newState), {
        onSuccess: () => {
            queryClient.invalidateQueries(["taskStates", filterDisplay]);
        },
    });
    // Mutation for updating a task state.
    const updateStateMutation = useMutation((state) => updateState(state), {
        onSuccess: () => {
            queryClient.invalidateQueries(["taskStates", filterDisplay]);
        },
    });
    // Mutation for deleting a task state.
    const deleteStateMutation = useMutation((id) => deleteState(id), {
        onSuccess: () => {
            queryClient.invalidateQueries(["taskStates", filterDisplay]);
        },
    });
    // Mutation for switching task states.
    const switchStatesMutation = useMutation(({ idState, idStateToSwitchWith }) => switchStateOrder(idState, idStateToSwitchWith), {
        onSuccess: () => {
            queryClient.invalidateQueries(["taskStates", filterDisplay]);
        },
    });
    return {
        taskStates: taskStatesData?.states ?? [],
        loading: isLoading,
        error: error ? error.message : null,
        refetchTaskStates: refetch,
        addTaskState: addStateMutation.mutateAsync,
        updateTaskState: updateStateMutation.mutateAsync,
        deleteState: deleteStateMutation.mutateAsync,
        switchStates: switchStatesMutation.mutateAsync,
    };
};
export default useTaskStates;
